import axios from './getAxios';
import { EventsPayloadProps } from './types';

export default async (payload: EventsPayloadProps) => {

  const { data } = await axios({
    method: 'GET',
    url: '/api/events/get',
    data: payload, 
  });
  return data;
};